<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h360_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="单位名称"
                    prop="unitName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.unitName"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="规格"
                    prop="specification"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.specification"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="所属物料"
                    prop="materialsId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.materialsId"
                      filterable
                      clearable
                      placeholder="请选择物料"
                      style="width:100%"
                      :disabled="eventType==='view'"
                      @change="changeMaterialsFun"
                    >
                      <el-option
                        v-for="item in materialsOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最小单位转换数量"
                    prop="minimumUnitConversionQuantity"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.minimumUnitConversionQuantity"
                      :disabled="eventType==='view'"
                      @input="(val)=>{limitPositiveInteger(val, dialogAddEditViewForm, 'minimumUnitConversionQuantity')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'minimumUnitConversionQuantity',2)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// API
import { listMaterialsApi } from '@/api/v2/materials';
// 数据请求
import { initMaterialsUnitConversionApi, saveOrUpdateMaterialsUnitConversionApi } from '@/api/materialsUnitConversion'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        unitName: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        specification: [{ required: true, message: '请输入规格', trigger: 'blur' }],
        materialsId: [{ required: true, message: '请选择所属物料', trigger: 'change' }],
        minimumUnitConversionQuantity: [{ required: true, message: '请输入最小单位转换数量', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      materialsOptions: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.materialsOptions = []
        this.dialogAddEditViewForm = {
          unitName: '',
          specification: '',
          materialsId: null,
          materialsName: '',
          minimumUnitConversionQuantity: '',
          remark: ''
        }
        this.initMaterialsSelectData()
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData() {
      initMaterialsUnitConversionApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 初始化所属物料下拉数据
    initMaterialsSelectData() {
      listMaterialsApi({ type: 2 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.materialsOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择物料回调
    changeMaterialsFun(val) {
      let selectItem = {}
      selectItem = this.materialsOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.materialsName = selectItem ? selectItem.label : ''
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '物料单位转换设置', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate() {
      saveOrUpdateMaterialsUnitConversionApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
